import { Inventory } from '@libs/common-node';
import { DisplayStore, SearchStore } from '@libs/common-types';
import { stringifyStoreId } from '@libs/core';

import { hasStock, validateStockStatus } from '../../../utils/stockStatusUtils';

const storeInventoryPart = ({
    store,
    inventory,
    minimumCaseQty,
}: {
    store: SearchStore;
    inventory: Inventory;
    minimumCaseQty?: number;
}): Partial<DisplayStore> => {
    const storeInventory = inventory[stringifyStoreId(store.Store.StoreNumber) as string] as number | undefined;

    const currentStoreStockstatus = validateStockStatus({
        stockQuantity: storeInventory as number,
        minimumCaseQty,
    });

    return {
        CurrentProductStockstatus: currentStoreStockstatus,
        HasCurrentProductInStock: hasStock(currentStoreStockstatus) ? storeInventory : 0,
    };
};

export const enhanceStoresWithInventory = (
    storeInventory: Inventory,
    storeList: SearchStore[],
    minimumCaseQty?: number
) =>
    storeList.map((s: SearchStore) => ({
        ...s,
        Store: {
            ...s.Store,
            ...storeInventoryPart({
                store: s,
                inventory: storeInventory,
                minimumCaseQty,
            }),
        },
    }));
